var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.processedSrc)?_c('img',{staticClass:"transparent-logo",attrs:{"src":_vm.processedSrc,"alt":"Logo"}}):_c('img',{ref:"originalImage",staticClass:"transparent-logo hidden",attrs:{"src":_vm.src,"alt":"Logo Original"},on:{"load":_vm.processImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }